import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import About from "@/components/About";
import Studios from "@/components/Studios";
import Mobilier from "@/components/Mobilier";
import Specific from "@/components/specificStudio";
import Renovations from "@/components/Renovation";
import SpecificRenovation from "@/components/SpecificRenovation";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: HelloWorld,
    },
    {
      path: "/about",
      name: "A propos de nous",
      component: About,
    },
    {
      path: "/studios",
      name: "Nos studios",
      component: Studios,
    },
    {
      path: "/mobilier",
      name: "Nos mobiliers sur mesure",
      component: Mobilier,
    },
    {
      path: "/studios/:id",
      name: "Nos",
      component: Specific,
    },
    {
      path: "/renovations/",
      name: "Renovation",
      component: Renovations,
    },
    {
      path: "/renovations/:id",
      name: "Nos renovations sur mesur",
      component: SpecificRenovation,
    },
  ],
});
